module.exports = __webpack_public_path__ + "img/tab-plus.fd72e799.svg";